module.exports = __webpack_public_path__ + "img/target1.4be200d5.png";